import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useStore } from "../../context/AppContext";
import { ModuloPermiso } from "../../types/admin-usuarios/ModuloPermiso";

export default function ProtectedRoutes(){
    const { state } = useStore();
    let location = useLocation();

    if (!state.user.authenticated) {
        return <Navigate to="/busqueda-documentos" replace />;
    }

    if(state.menu.modulos && location.pathname !== "/" && !state.menu.modulos.find((m: ModuloPermiso)=> m.route.includes(location.pathname))){
        return <Navigate to="/" replace />;
    }
    
    return <Outlet />;
}